export default "__VITE_ASSET__DvNjXuZD__"